/**
 * Stelle eine geeignete Situation her für die gewählte AnMauer-Option
 */
import { createMauer } from "../testsE2E/utils";
import { MASSE } from "./Masse";
import { SizeNumber } from "../components/SizeNumber";
import { v3 } from "oc-threejs/short3";
import { isEmpty } from "oc-commons/Commons";
import { cutBetween } from "oc-commons/Maths";
import * as Dialogs from "oc-ui/dialogs/Dialogs";

function getLichteWeiteDialogJsx(defaultValue: number) {
  return (
    <section aria-labelledby="lichte-weite-heading">
      <h3 id="lichte-weite-heading">
        {I18N("Bitte geben Sie die Lichte Weite zwischen den Mauern ein")}
      </h3>
      <div
        className={"lichteWeiteInputWrapper"}
        role="group"
        aria-labelledby="lichte-weite-heading"
      >
        <label htmlFor="lichteWeiteInput" id="lichteWeiteLabel">
          {I18N("Lichte Weite")} &nbsp;
        </label>
        <SizeNumber
          value={defaultValue}
          setter={(value) => {}}
          disabled={false}
          className={"lichteWeiteInput"}
          min={64}
          max={244}
          decimals={0}
          unit={"cm"}
          step={1}
          workOnInternValue={true}
          aria-labelledby="lichteWeiteLabel"
          aria-describedby="lichte-weite-heading"
        />
      </div>
    </section>
  );
}

export async function updateAnMauer(gegebeneLichteWeite?: number | null) {
  const konf = APP.arrangement.konfiguration;
  const segmentBreite = 20;
  const mauerLinksPosition = v3(-segmentBreite / 2 - 0.5, 0, 0);
  const mauerRechtsPosition = v3(segmentBreite / 2 + 0.5, 0, 0);
  const mauerSize = v3(1, 2, 0.5);

  // Immer gleiche Bedingungen herstellen:
  konf.arrangement.aufbauten = [];
  konf.currentElement.snap = -1;
  konf.arrangement.savedElemente = konf.arrangement.getElemente();

  if (konf.isAnMauerBeide()) {
    if (!konf.currentElement.isBreiteKonfigurierbar) {
      konf.setDefault("DetailSerie");
    }

    const lichteWeite = gegebeneLichteWeite || (await askForLichteWeite());
    if (isEmpty(lichteWeite) || lichteWeite < 0.01) {
      konf.setAnMauer();
      return;
    }

    konf.currentElement.uiRemove();
    konf.arrangement.update3d();

    createMauer({ position: mauerLinksPosition, size: mauerSize });
    createMauer({
      position: v3(mauerLinksPosition.x + 1 + lichteWeite + 0.00001, 0, 0),
      size: mauerSize,
    });

    setTimeout(() => {
      konf.currentElement.setKonfigurierbareBreite(lichteWeite - 0.05);
      konf.currentElement.updateSize();
      if (APP.arrangement.getEmpties().length > 1) {
        APP.arrangement.getEmpties()[0].fillWithElements(konf.currentElement, {
          allowMassElement: true,
          allowToGrowToMaximum: true,
          minimalOneElement: true,
          maximumNumberOfElements: 1,
        });
      }
      (window as any).currentElement = konf.currentElement;
    }, 200);
  } else if (konf.AnMauer.Key == "AnMauer_rechts") {
    createMauer({ position: mauerLinksPosition, size: mauerSize });
    konf.currentElement.position.x = segmentBreite / 2;
    konf.currentElement.snap = -1;
  } else if (konf.AnMauer.Key == "AnMauer_links") {
    createMauer({ position: mauerRechtsPosition, size: mauerSize });
    konf.currentElement.position.x = 0.5;
    konf.currentElement.snap = 1;
  }
  APP.dirty();
}

/**
 * Frage den User nach der gewünschten Lichten Weite für AnMauer_beide
 */
async function askForLichteWeite(): Promise<number> {
  const konf = APP.arrangement.konfiguration;
  let lichteWeite = konf.getMass(MASSE.LichteWeite) * 100;
  const lichteWeiteInput = await Dialogs.askQuestionWithInputPromise(
    getLichteWeiteDialogJsx(lichteWeite)
  );
  if (isEmpty(lichteWeiteInput)) {
    konf.setAnMauer(null);
    return;
  }
  // max für lichteWeite ist 244 (cm), da Eingabe in cm erfolgt und max 2.44m ist
  const userLichteWeite = I18N.parseFloat(lichteWeiteInput, 244) / 100;
  if (!isNaN(userLichteWeite)) {
    lichteWeite = cutBetween(0.64, userLichteWeite, 2.44);
    const maxEinzeltorLichteWeite = 1.24;
    const minDoppeltorLichteWeite = 1.22;
    if (lichteWeite > maxEinzeltorLichteWeite && konf.isEinzeltor()) {
      const oldAnMauer = konf.AnMauer;
      konf.setWorkflow(
        APP.metadata.Workflow_Auswahlwert.find((x) => x.Key == "WORKFLOW_Doppeltor")
      );
      konf.AnMauer = oldAnMauer;
    } else if (lichteWeite < minDoppeltorLichteWeite && konf.isDoppeltor()) {
      const oldAnMauer = konf.AnMauer;
      konf.setWorkflow(
        APP.metadata.Workflow_Auswahlwert.find((x) => x.Key == "WORKFLOW_Einzeltor")
      );
      konf.AnMauer = oldAnMauer;
    }
  }
  return lichteWeite;
}
